import { render } from "./SystemSubjectsContent.vue?vue&type=template&id=429df047&ts=true"
import script from "./SystemSubjectsContent.vue?vue&type=script&lang=ts"
export * from "./SystemSubjectsContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__